const InfoMessage = ({ children }: React.HTMLAttributes<HTMLParagraphElement>) => {
  return <p className="text-gray-900 py-1 px-2 rounded-md bg-green-50">🌈 {children}</p>;
};

export default InfoMessage;
